import * as types from './types';
import { createAction } from '../../models/redux/CreateAction';

export const fetchMyCustomers = (payload: { filter: {} }) => {
  return createAction(types.GET_MY_CUSTOMERS_REQUEST, payload);
};
